import React from 'react'
import "./Address.scss"
import icon from "./../../Assets/sideicone.png"
export default function Address({title}) {
  return (
    <div>
      <div className='bg-title'>
      <h6>{title}</h6>

<img src={icon} width={40} height={40} alt="" />
      </div>
    </div>
  )
}
